import React, { useState } from "react";
import { Link } from "react-router-dom";
import ResultInfoText from "../ResultsTable/ResultInfoText.js";
import { speciesLink } from "../../functions/taxonomyLinks.js";
import "./SpeciesList.css";

// The "Species in <kingdom>" block of a kingdom page: every species of the
// kingdom with its enzyme count, ordered by that count, each linking to its own
// species page. `speciesCounts` is the [[species, enzymeCount], ...] list from
// functions/taxonomySummary.js (already sorted).
function SpeciesList({ speciesCounts, startingDisplay = 40, displayStep = 40 }) {
  const [displayNumber, setDisplayNumber] = useState(startingDisplay);

  if (speciesCounts.length === 0) {
    return <div>No species with reactions in MARTS.</div>;
  }

  return (
    <>
      <div className="species-list">
        {speciesCounts.slice(0, displayNumber).map(([species, count]) => (
          <Link key={species} to={speciesLink(species)} className="species-list-item">
            <span>{species}</span>
            <span className="species-list-count">{count}</span>
          </Link>
        ))}
      </div>
      {displayNumber < speciesCounts.length && (
        <div>
          <button className="basic-button" onClick={() => setDisplayNumber(displayNumber + displayStep)}>
            Show more
          </button>
          <ResultInfoText
            text={`Showing ${displayNumber} of ${speciesCounts.length} species`}
            row={1}
          />
        </div>
      )}
    </>
  );
}

export default SpeciesList;
